import { render, staticRenderFns } from "./CreateUpdateKeywordAttributePopup.vue?vue&type=template&id=165f33c4"
import script from "./CreateUpdateKeywordAttributePopup.vue?vue&type=script&lang=js"
export * from "./CreateUpdateKeywordAttributePopup.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdateKeywordAttributePopup.vue?vue&type=style&index=0&id=165f33c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports